<template>
	<div class="main-containter" v-title data-title="和华利盛-首页">
		<PHeader :checkId="'专业文章15'"  :activeNames="'资讯动态'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">资讯动态</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Information Dynamics</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 / 专业文章</span>
				<span style="color:#333333;font-size:14px;"> / 内容详情</span>
			</div>
			<div style="width:94%;margin-left:3%;margin-bottom:20px;margin-top:20px;">
				<div style="text-align: center;padding-bottom: 20px;border-bottom: 1px solid #D7D7D7;">
					<div style="font-size: 22px;color: black;">{{item.title}}</div>
					<div style="padding-top: 5px;font-size: 14px;color: rgb(170, 170, 170);margin-bottom: 20px;text-align: left;">发布时间：{{item.publish.substring(0,10)}}</div>
					<v-md-preview  style="text-align:left;" :text="item.content" ref="preview"  id="preview"></v-md-preview>
				</div>
				<div style="margin-top: 20px;">
					<div class="upAndDown" style="font-size: 14px;color:#7F7F7F;width: 50%;overflow: hidden;text-overflow: ellipsis;white-space: normal;height: 20px;" @click="toUp()">上一篇：{{up.title}}</div>
					<div class="upAndDown" style="font-size: 14px;margin-top:10px;margin-bottom:20px;color:#7F7F7F;width: 50%;text-align: left;overflow: hidden;text-overflow: ellipsis;white-space: normal;height: 20px;" @click="toNext()">下一篇：{{next.title}}</div>
				</div>
			</div>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {queryNext} from "@/api/article";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				id: 0,
				item: {},
				up: {},
				next: {},
			}
		},
		created() {
			this.id = this.$route.query.id
			this.queryNext()
		},
		mounted() {
			this.id = this.$route.query.id
			this.queryNext()
		},
		activated() {
			this.id = this.$route.query.id
			this.queryNext()
		},
		methods: {
			queryNext(){
				let param = {}
				param.id = this.id
				queryNext(param).then(data => {
						this.item = data.data.item
						this.up = data.data.up
						this.next = data.data.next
					}).catch(error => {
						this.$message.error(error)
				})
			},
			async toNext(){
				let that = this
				if(this.next.id != 0){
					this.id = this.next.id
					this.queryNext()
				}else{
					this.$message.error("无下一篇。")
				}
			},
			async toUp(){
				let that = this
				if(this.up.id != 0){
					this.id = this.up.id
					this.queryNext()
				}else{
					this.$message.error("无上一篇。")
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.upAndDown:hover{
		color: #98273A;
	}
	.upAndDown{
		cursor: pointer;
	}
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter /deep/ .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel /deep/ .el-carousel__container{
		height: 100%;
	}
	body /deep/ .v-modal{
		display: none;
	}
</style>
